import {Component, OnInit} from "@angular/core";
import {New} from "../new";
import {NewService} from "../new.service";
import {Router} from "@angular/router";
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container2">
        <div class="title-clothes">
        2025/11/05 - "STIGA" HELIX PLATINUM 膠皮 👊🏻👊🏻👊🏻 到貨‼️‼️‼️

        </div>

        <p class="news_content_wrap">
        STIGA HELIX PLATINUM  海力克士桌球膠皮 👊🏻👊🏻👊🏻 到貨‼️‼️‼️
        
        👉👉👉專為高強度比賽而生的🎖世界級膠皮✌️
        每次擊球能量回彈提升高達11%，回球更快速☄️更省力
        增強彈性設計，以更少效能製造更強🌀旋轉和速度🚀
        更高的出球軌跡在高速對抗中可精準地掌控🎯落點🚀
        【Helix Platinum XH】
        WTT冠軍🏆小莫使用🏓
        超硬海綿適合技術純熟、能快速掌控比賽的球員
        🔸️控制71/速度174/旋轉142
        🔸️厚度2.2/硬度52.5
        －－－－－－－－－－－－
        【Helix Platinum H】
        硬海綿兼顧速度與控制－推薦給渴望突破極限又不失控感的球員
        🔸️控制73/速度170/旋轉142
        🔸️厚度2.2/硬度50
        －－－－－－－－－－－－
        【Helix Platinum M】
        中硬海綿兼顧速度與控制，適合喜歡變換節奏的選手
        🔸️控制75/速度166/旋轉142
        🔸️厚度2.2/硬度47.5
        </p> 
        
        <div class="detailimg">
        <img src="../../../img/detail2/img1.jpg" height="500px" class="detailautoimg">
        <img src="../../../img/detail2/img2.jpg" height="500px" class="detailautoimg">
        </div>


        
       <button class="sharebutton" (click)="Facebook()"><img src="../../../img/fb-live-map_2.png" width="60px"></button>
       <button class="sharebutton" (click)="Google()"><img src="../../../img/photo.jpg" width="50px"></button>
       <button class="sharebutton" (click)="Twitter()"><img src="../../../img/Twitter.png" width="50px"></button>
      
       </div>
       
       
       
       <div class="new_button" style="text-align: center;margin-bottom: 30px;width:150px;margin:auto;margin-bottom:30px;">
       <button style="color: white;background-color: #CC3366;border: none;" (click)="gotoHome()">回到首頁</button></div>
    `,
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class Detail2Component implements OnInit{
  public ptitle:string;
  public pcontent:string;
  constructor(private newservice:NewService,private router:Router){}
  ngOnInit(){
    this.ptitle=this.newservice.getTitle()
    
    this.pcontent=this.newservice.getContent()
  }
  gotoHome(){
    this.router.navigate(['/']);
  }
  Facebook() {
    void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href)) ));
  }
  Google(){
    void(window.open('https://lineit.line.me/share/ui?url='.concat(encodeURIComponent(location.href)) ));
  }

  Twitter(){
    void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(location.href))));
  }


}



// WEBPACK FOOTER //
// ./src/app/news/detail/detail2.component.ts